import React from "react";
import TextArea from "carbon-react/lib/__experimental__/components/textarea";
import StepTitle from "../../../../common/stepTitle/StepTitle";
import LanguageSelector from "../../../../common/languageSelector/LanguageSelector";
import DialogConfirmButtons from "../../../../common/dialogConfirmButtons/DialogConfirmButtons";

const SendCodeStep = ({
  user,
  busy,
  state,
  onStateChanged,
  onCancel,
  onCompleted,
}) => {
  const onCancelClicked = () => {
    if (isAValidFunc(onCancel)) onCancel();
  };

  const onSendClicked = () => {
    if (!validateStep()) return;
    if (isAValidFunc(onCompleted)) onCompleted();
  };

  const validateStep = () => {
    let result = true;

    if (!validateLanguageCode()) result = false;
    if (!validateAgentComments()) result = false;

    return result;
  };

  const validateLanguageCode = () => {
    const valid = state.languageCode && state.languageCode.length > 0;
    updateState(() => {
      state.languageCodeValid = valid;
    });
    return valid;
  };

  const validateAgentComments = () => {
    const sanitizedComments = state.agentComments
      ? state.agentComments.trim()
      : "";
    const valid = sanitizedComments.length > 0 ? true : false;
    updateState(() => {
      state.agentComments = sanitizedComments;
      state.agentCommentsValid = valid;
    });
    return valid;
  };

  const onLanguageCodeChanged = (languageCode) => {
    updateState(() => {
      state.languageCodeValid = true;
      state.languageCode = languageCode;
    });
  };

  const onAgentCommentsChanged = (agentComments) => {
    const sanitizedComments =
      agentComments && agentComments.length > 0 ? agentComments : "";
    updateState(() => {
      state.agentCommentsValid = true;
      state.agentComments = sanitizedComments;
    });
  };

  const isAValidFunc = (func) => {
    return func && typeof func === "function";
  };

  const updateState = (mutateState) => {
    if (isAValidFunc(mutateState)) mutateState();
    onStateChanged({ ...state });
  };

  const languageSelection = (
    <LanguageSelector
      id="delete-mfa-enrollment-select-language"
      autoFocus
      required={false}
      appearBusy={busy}
      value={state.languageCode}
      onValueChanged={(languageCode) => {
        onLanguageCodeChanged(languageCode);
      }}
      onBlur={validateLanguageCode}
      appearInvalid={!state.languageCodeValid}
      validationMsg="Language must be provided"
    />
  );

  const agentCommentsWarningAttributes = {
    hasWarning: true,
    inputIcon: "warning",
    tooltipMessage: "Please indicate why this action is being performed",
  };

  const buttons = (
    <DialogConfirmButtons
      appearBusy={busy}
      confirmBtnEnabled={true}
      confirmBtnLabel="Send code"
      onConfirm={onSendClicked}
      onCancel={onCancelClicked}
    />
  );

  const agentCommentsInput = (
    <TextArea
      id="delete-mfa-enrollment-agent-comments"
      placeholder={agentCommentsWarningAttributes.tooltipMessage}
      label="Comments"
      disabled={busy}
      value={state.agentComments}
      characterLimit={"250"}
      enforceCharacterLimit={true}
      name="agentComments"
      onChange={(e) => {
        onAgentCommentsChanged(e.target.value);
      }}
      onBlur={validateAgentComments}
      {...(!state.agentCommentsValid ? agentCommentsWarningAttributes : {})}
    />
  );

  return (
    <div id="send-code-step" className="delete-mfa-enrollment-send-code-step">
      <div className="delete-mfa-enrollment-step-body">
        {languageSelection}
        {agentCommentsInput}
      </div>
      {buttons}
    </div>
  );
};

export default SendCodeStep;
